import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ReportRequest = {
	name: NAME,
	apiProvider,
	router,
};
